define('app/sdc/browser/compatibility/modal/sdc-browser-compatibility-modal',[], function () {
	return {
		restrict: "A",
		template: null,
		controller: {
			constructor: ["$element", "$scope", "$self", function ($element, $scope, vm) {
				vm.close = function () {
					$element.remove();
					$scope.$destroy();
				}
			}]
		}
	};
});
